module.exports = __webpack_public_path__ + "assets/img/lanzhouBank.e7fa1e27.png";